<template>
  <form>
    <validation-observer ref="formfile">
      <div class="columns is-multiline">
        <div class="column is-5" v-show="model.fileType != 'Link'">
          <div class="field">
            <label class="label">Choose file</label>
            <div class="control">
              <div class="file has-name is-fullwidth is-right">
                <label class="file-label">
                  <input
                    ref="fileToUpload"
                    class="file-input"
                    type="file"
                    :multiple="isCreate"
                    @change="handleFileChange"
                  />
                  <span class="file-cta">
                    <span class="file-icon">
                      <i class="icon icon-upload"></i>
                    </span>
                    <span class="file-label">
                      Upload
                    </span>
                  </span>
                  <span class="file-name">
                    {{ (fileBlob && fileBlob.name) || 'No file selected' }}
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-2 file-or-link" v-show="!model.fileType">
          OR
        </div>
        <div
          class="column is-5"
          v-show="model.fileType == 'Link' || !model.fileType"
        >
          <div class="field">
            <label class="label">Enter a link</label>
            <div class="control">
              <input
                v-model="model.linkUrl"
                type="url"
                class="input"
                placeholder="http://"
                @focus="focusLink"
              />
            </div>
          </div>
        </div>
        <div
          v-if="fileBlob && isVideoFile(fileBlob)"
          class="column is-12 is-research-video"
        >
          <app-checkbox v-model="isResearchVideo" class="large">
            Is this file a Research Video?
          </app-checkbox>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label">Displayed File Name</label>
            <div class="control">
              <validation-provider v-slot="{ errors, failed }" rules="required">
                <input
                  v-model="model.name"
                  type="text"
                  class="input"
                  :class="{ 'is-danger': failed }"
                />
                <span class="help is-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label">Add Notes (optional)</label>
            <div class="control">
              <textarea v-model="model.description" class="input"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="create-dialog-actions">
        <div class="button is-primary" @click="handleFileUpload">
          Save
        </div>
      </div>
    </validation-observer>
  </form>
</template>

<script>
import Form from './Form.js';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import '@/validation.js';
import axios from 'axios';
import FilesHelper from '@/mixins/Files.js';
import { CognitoIdentityCredentials, config, S3 } from 'aws-sdk';
import AppCheckbox from '../AppCheckbox';

// S3 properties
const bucketRegion = 'us-west-2';
const identityPoolId = 'us-west-2:cb03d30c-2a41-48ae-9e34-bb1898375c0f';

export default {
  name: 'FileForm',
  components: {
    AppCheckbox,
    ValidationProvider,
    ValidationObserver
  },
  extends: Form,
  mixins: [FilesHelper],
  props: ['fileToUpload', 'selectedFileId', 'projectId', 'active'],
  watch: {
    fileToUpload() {
      this.fileBlob = this.fileToUpload;
    },
    active(newval, oldval) {
      if (newval != oldval && newval) {
        this.$refs.fileToUpload.value = '';
        this.fileBlob = '';
      }
    }
  },
  mounted() {
    // Create an AWS Cognito identity pool with permissions to write to
    // the S3 bucket
    console.log('mount fileform');
    config.update({
      region: bucketRegion,
      credentials: new CognitoIdentityCredentials({
        IdentityPoolId: identityPoolId
      })
    });
  },
  computed: {
    isCreate() {
      if (this.selectedFileId == -1) return true;
      else return false;
    }
  },
  methods: {
    async handleFileChange(e) {
      this.filesUploading = [];
      this.model.fileType = 'File';
      this.fileBlob = this.$refs.fileToUpload.files[0];

      if (this.$refs.fileToUpload.files.length > 1) {
        this.multiFiles = this.$refs.fileToUpload.files;
      }

      this.isResearchVideo = false;
    },
    focusLink() {
      console.log('Focus');
      //this.model.fileType = 'Link';
      this.$set(this.model, 'fileType', 'Link');
    },
    handleFileUpload() {
      if (this.multiFiles.length > 0) {
        for (var i = 0; i < this.multiFiles.length; i++) {
          if (this.isResearchVideo) {
            this.model.fileKey = this.buildS3VideoUploadKey(
              this.projectId,
              this.multiFiles[i].name
            );
          } else {
            this.model.fileKey = this.buildS3FileUploadKey(
              this.projectId,
              this.multiFiles[i].name
            );
          }

          this.model.name = this.multiFiles[i].name;
          this.model.name = this.model.name.substr(
            0,
            this.model.name.lastIndexOf('.')
          );

          this.uploadFileToS3(
            this.multiFiles[i],
            Object.assign({}, this.model)
          );
        }
        this.$emit('created', this.model, this.multiFiles.length);
      } else {
        if (this.fileBlob) {
          if (this.isResearchVideo)
            this.model.fileKey = this.buildS3VideoUploadKey(
              this.projectId,
              this.fileBlob.name
            );
          else
            this.model.fileKey = this.buildS3FileUploadKey(
              this.projectId,
              this.fileBlob.name
            );
        }

        this.$refs.formfile.validate().then(success => {
          if (!success) {
            this.showErrorMessage('Please check the errors');
            return;
          } else {
            if (this.selectedFileId != -1) {
              console.log('update no file form', this.fileBlob);

              if (this.fileBlob) {
                this.uploadFileToS3(
                  this.fileBlob,
                  Object.assign({}, this.model)
                );
                this.$emit('updated', this.model);
              } else {
                this.updateFile(this.fileBlob, this.model);
              }
            } else {
              console.log('post no file form', this.fileBlob);
              if (this.fileBlob) {
                this.uploadFileToS3(
                  this.fileBlob,
                  Object.assign({}, this.model)
                );
                this.$emit('created', this.model);
              } else {
                this.createFile(this.fileBlob, this.model);
              }
            }
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
textarea {
  height: 100px;
}

.is-research-video {
  margin-bottom: 20px;
}

.file-or-link {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: $weight-bold;
}
</style>
